import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

const closeShortSalesOrderItemRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/sales-orders/:id/close-short/:itemId ',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/sales-orders/:id/close-short/:itemId' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const closeShortSalesOrderItemResponse: Json = {
    title: 'RESPONSE',
    json: {
        "id": 134,
        "number": "10141",
        "carrier": {
            "id": 5,
            "name": "USPS",
            "service": {
                "id": 16,
                "name": "Priority Mail"
            }
        },
        "fobPointName": "Origin",
        "paymentTerms": {
            "id": 1,
            "name": "COD"
        },
        "customer": {
            "id": 52,
            "name": "Allan's Raceway"
        },
        "vendorPoNumber": "",
        "customerPoNumber": "",
        "customerContact": "Allan's Raceway",
        "salesperson": {
            "id": 1,
            "name": "admin"
        },
        "deliverTo": "Allan's Raceway",
        "revisionNumber": 3,
        "lastModified": {
            "username": "admin",
            "dateLastModified": "2025-04-18T11:27:51.660-06"
        },
        "dateCreated": "2025-04-18T00:00:00.000-06",
        "dateScheduled": "2025-04-18T00:00:00.000-06",
        "dateCompleted": "2025-04-18T11:27:51.602-06",
        "totalTax": "0.8",
        "totalPrice": "10.8",
        "mcTotalTax": "0.8",
        "mcTotalPrice": "10.8",
        "totalIncludesTax": false,
        "locationGroup": {
            "id": 5,
            "name": "SLC"
        },
        "note": "",
        "url": "",
        "email": "",
        "phone": "801-932-1101",
        "shipToAddress": {
            "name": "Allan's Raceway",
            "street": "2222 Wrecker's Blvd",
            "city": "Santa Barbara",
            "state": "CA",
            "postalCode": "93101",
            "country": "UNITED STATES"
        },
        "billToAddress": {
            "name": "Allan's Raceway",
            "street": "2222 Wrecker's Blvd",
            "city": "Santa Barbara",
            "state": "CA",
            "postalCode": "93101",
            "country": "UNITED STATES"
        },
        "status": "Closed Short",
        "class": {
            "id": 12,
            "name": "LA:LA Store"
        },
        "shipTerms": "Prepaid & Billed",
        "type": "Standard",
        "soItems": [
            {
                "id": 292,
                "product": {
                    "id": 81,
                    "name": "B203",
                    "description": "Basic Brake Cables"
                },
                "type": {
                    "id": 10,
                    "name": "Sale"
                },
                "uom": {
                    "id": 1,
                    "name": "Each",
                    "abbreviation": "ea"
                },
                "lineNumber": 2,
                "customerPartNumber": "",
                "unitPrice": "10",
                "totalTax": "0.8",
                "totalPrice": "10",
                "mcTotalTax": "0",
                "mcTotalPrice": "0",
                "taxRate": {
                    "id": 5,
                    "name": "Cal Tax",
                    "rate": 0.08
                },
                "dateLastFulfilled": "2025-04-18T11:27:31.404-06",
                "dateScheduled": "2025-04-18T11:24:28.066-06",
                "revision": "",
                "note": "",
                "status": "Closed Short",
                "quantity": "1",
                "quantityFulfilled": "1",
                "quantityPicked": "0",
                "class": {
                    "id": 12,
                    "name": "LA:LA Store"
                },
                "customFields": []
            }
        ],
        "customFields": [
            {
                "id": 20,
                "name": "Custom",
                "value": "",
                "type": "Text"
            }
        ]
    }
};

const data: RequestDefinitionData = {
    id: 'close-short-sales-order-item',
    title: 'Close short a sales order item',
    description: 'Close short a sales order item with the specified ID.',
    endpoint: {
        verb: 'POST',
        path: '/sales-orders/:id/close-short/:itemId',
        tooltip: 'Close short a sales order item',
    },
    attributes: [],
    requestObject: closeShortSalesOrderItemRequest,
    responseObject: closeShortSalesOrderItemResponse,
};

export default data;
